import { PercentAmpel } from 'app/components/common/PercentAmpel';
import Widget from 'app/components/common/Widget';
import { useStore } from 'app/context';
import { NachfolgePlanungVm } from 'app/stores/ui/nachfolgeplanung.ui.store';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

interface AgtNachfolgePlanungDigitalReportProps {
	agtId: number;
}

export const AgtNachfolgePlanungDigitalReport = observer(({ agtId }: AgtNachfolgePlanungDigitalReportProps) => {
	const { nachfolgeplanungUiStore } = useStore();
	const [vm, setVm] = useState<NachfolgePlanungVm | null>(null);

	useEffect(() => {
		nachfolgeplanungUiStore.load().then(() => {
			const found = nachfolgeplanungUiStore.items.find((item) => item.agtId === agtId);
			setVm(found || null);
		});
	}, [agtId, nachfolgeplanungUiStore]);

	if (!vm) {
		return null;
	}

	return (
		<div className="table-container is-boxed">
			<table className="table is-fullwidth is-narrow is-striped">
				<thead>
					<tr>
						<th>Digital-Report</th>
						<th className="has-text-right">Ziel</th>
						<th className="has-text-right">Ergebnis</th>
						<th className="has-text-right">ZE</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>mAZ Bestandskunden</td>
						<td className="has-text-right">75 %</td>
						<td className="has-text-right">
							<PercentAmpel value={vm.prozMaz18} yellowMin={30} greenMin={60} />
						</td>
						<td className="has-text-right">{vm.prozMaz18 > 0 ? `${Math.round((vm.prozMaz18 / 75) * 100)} %` : '-'}</td>
					</tr>
					<tr>
						<td>wEWE Bestandskunden</td>
						<td className="has-text-right">75 %</td>
						<td className="has-text-right">
							<PercentAmpel value={vm.prozWewe18} yellowMin={35} greenMin={60} />
						</td>
						<td className="has-text-right">{vm.prozWewe18 > 0 ? `${Math.round((vm.prozWewe18 / 75) * 100)} %` : '-'}</td>
					</tr>
					<tr>
						<td>Digi-ID Bestandskunden</td>
						<td className="has-text-right">75 %</td>
						<td className="has-text-right">
							<PercentAmpel value={vm.prozDigiId18} yellowMin={60} greenMin={85} />
						</td>
						<td className="has-text-right">{vm.prozDigiId18 > 0 ? `${Math.round((vm.prozDigiId18 / 75) * 100)} %` : '-'}</td>
					</tr>
					<tr>
						<td>mAZ Neukunden</td>
						<td className="has-text-right">80 %</td>
						<td className="has-text-right">85 %</td>
						<td className="has-text-right">108 %</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
});
